import React from 'react';

/**
 * Renders a horizontal row of action buttons in a panel header.
 *
 * @param {Array} actions - Array of action descriptors:
 *   { label: string, onClick: function, requiresSelection?: boolean, requiresLinkedSurvey?: boolean, hideWhen?: (state) => boolean, primary?: boolean }
 * @param {*} selection - Current selection (truthy = has selection)
 * @param {object} state - State object passed to hideWhen predicates
 */
export default function PanelHeaderActions({ actions = [], selection, state = {} }) {
    if (!actions || actions.length === 0) return null;

    return (
        <div style={{
            display: 'flex',
            gap: 6,
            alignItems: 'center',
            flexWrap: 'wrap',
        }}>
            {actions.map((action, i) => {
                // State-aware visibility: hide entirely when hideWhen returns true
                if (action.hideWhen && action.hideWhen(state)) return null;

                const disabled = (action.requiresSelection && !selection)
                    || (action.requiresLinkedSurvey && !(state.linkedSurveys?.length > 0))
                    || (action.disabledWhen && action.disabledWhen(state));

                return (
                    <button
                        key={action.label + i}
                        onClick={action.onClick}
                        disabled={disabled}
                        style={{
                            padding: '3px 10px',
                            fontSize: 12,
                            fontWeight: 500,
                            border: '1px solid #DADCE0',
                            borderRadius: 4,
                            background: action.primary ? '#E8F0FE' : '#fff',
                            color: disabled ? '#BDC1C6' : '#3C4043',
                            cursor: disabled ? 'default' : 'pointer',
                            opacity: disabled ? 0.5 : 1,
                            transition: 'opacity 0.15s, background 0.15s',
                            lineHeight: '22px',
                            whiteSpace: 'nowrap',
                        }}
                        title={disabled
                            ? (action.disabledReason?.(state) || action.label)
                            : action.label}
                    >
                        {action.label}
                    </button>
                );
            })}
        </div>
    );
}
